import type { PropsWithChildren } from "react";
import { useEffect, useMemo, useReducer } from "react";
import { useIsLogged } from "../../../hooks/use-is-logged/use-is-logged";
import { ChatbotContext } from "../chatbot.context";
import { AI_CHATBOT_ACTIONS } from "../lib/reducer/actions/actions";
import { chatbotInitialState, chatbotReducer } from "../lib/reducer/chatbot.reducer";
import { chatbotSessionService } from "../lib/services/chatbot-session/chatbot-session.service.instance";

export function ChatbotProvider({ children }: Readonly<PropsWithChildren<{}>>): JSX.Element {
  const [state, dispatch] = useReducer(chatbotReducer, chatbotInitialState);
  const isLogged = useIsLogged();

  const value = useMemo(
    function memoizeChatbotProviderValue() {
      return { state, dispatch };
    },
    [state, dispatch]
  );

  useEffect(
    function initializeChatbotMessages() {
      if (!isLogged) {
        return dispatch({ type: AI_CHATBOT_ACTIONS.RESET });
      }

      async function populateChatbotMessagesWithLatestSession() {
        const oldMessages = await chatbotSessionService.getActiveSessionMessages();

        if (oldMessages && oldMessages.length > 0) {
          dispatch({
            type: AI_CHATBOT_ACTIONS.POPULATE_CHAT_MESSAGES,
            payload: { messages: oldMessages },
          });
        }
      }
      populateChatbotMessagesWithLatestSession();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isLogged]
  );

  return <ChatbotContext.Provider value={value}>{children}</ChatbotContext.Provider>;
}
